// extracted by mini-css-extract-plugin
module.exports = {"container":"empty_container__srKuI","description":"empty_description__leXdh","pleaseUseDifferentKeyword":"empty_pleaseUseDifferentKeyword__ktvSQ"};